import { type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { type MeIndicacao } from '@varga/shared';
import { dataCurta } from '../lib/formato';
import { IconeSeta } from './icones';

/**
 * `ListaIndicacoes` (DESIGN-FOUNDATION §6.6) — nível 1, hairlines, sem card.
 * **Só as convertidas** (a API já filtra; rejeitadas nunca aparecem — UX §5.5).
 * Na Home: 3 linhas + "Ver todas". Vazio → estado que convida a indicar
 * (renderizado pela tela).
 */
export function ListaIndicacoes({
  itens,
  limite,
  verTodas = false,
}: {
  itens: MeIndicacao[];
  limite?: number;
  verTodas?: boolean;
}): ReactNode {
  const visiveis = limite ? itens.slice(0, limite) : itens;
  return (
    <div>
      <ul className="divide-y divide-linha border-y border-linha">
        {visiveis.map((i, idx) => (
          <li
            key={`${i.primeiroNome}-${i.convertidaEm}-${idx}`}
            className="flex min-h-[56px] flex-col justify-center py-2"
          >
            <p className="tipo-corpo text-tinta-forte">
              <span className="tipo-corpo-forte">{i.primeiroNome}</span>{' '}
              <span className="tipo-nota text-tinta-3">
                · {dataCurta(i.convertidaEm)}
                {i.brindeDescricao ? ` · rendeu ${i.brindeDescricao}` : ''}
              </span>
            </p>
          </li>
        ))}
      </ul>
      {verTodas && limite && itens.length > limite && (
        <Link
          to="/indicacoes"
          className="mt-3 inline-flex min-h-[48px] items-center gap-1 tipo-apoio text-acento-texto"
        >
          Ver todas
          <IconeSeta width={16} height={16} />
        </Link>
      )}
    </div>
  );
}
